import "./modalGeneric.css";
import React from "react";
import { ModalButtons } from "../ModalButtons/modalButtons";
import Input from "../fluxo-engenheiro/formBasic/Input";

interface ModalField {
  name: string;
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  maskFunction?: (value: string) => string;
  applyMask?: boolean;
  error?: string;
  required?: boolean;
}

interface GenericModalProps {
  title?: string;
  description?: React.ReactNode;
  fields: ModalField[];
  primaryButton: string;
  secondaryButton?: string;
  tertiaryButton?: string;
  onConfirm: () => void;
  onClose: () => void;
  onThirdAction?: () => void;
  isSubmitting?: boolean;
  isConfirmDisabled?: boolean;
  className?: string;
}

export const GenericModal = ({
  title,
  description,
  fields,
  primaryButton,
  secondaryButton,
  tertiaryButton,
  onConfirm,
  onClose,
  onThirdAction,
  isSubmitting,
  isConfirmDisabled,
  className,
}: GenericModalProps) => {
  return (
    <div className={`smallModalCorporateSession ${className}`}>
      <div className="smallModal">
        <div>
          <div className="containerTitleSmallModal">
            {title && <h1 className="titleSmallModal">{title}</h1>}
          </div>

          <div className="containerDescription">
            {description && (
              <span className="bodySmallModal">{description}</span>
            )}

            {fields.map((field) => (
              <div key={field.name} style={{ marginTop: 25 }}>
                {field.label && (
                  <span className="lineLabelSmallInput">
                    {field.label}
                  </span>
                )}

                <Input
                  id={field.name}
                  label=""
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  maskFunction={field.maskFunction}
                  applyMask={field.applyMask}
                  width={"39.3ch"}
                />

                {field.error && (
                  <span className="errorText">{field.error}</span>
                )}
              </div>
            ))}

            <ModalButtons
              buttonOne={primaryButton}
              buttonTwo={secondaryButton}
              buttonThree={tertiaryButton}
              onConfirm={onConfirm}
              onClose={onClose}
              onLogout={onThirdAction}
              isButtonDisabled={isConfirmDisabled}
              isSubmitting={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
